// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Container, Group, Stack } from '@mantine/core';
import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useModalState } from '../../../Molecules/Dialogs';
import { useAddon } from '../../../Service/Context/BookitupSubscriptionContext';
import { ProfileContext } from '../../../Service/Context/ProfileContext';
import { ViolationContext } from '../../../Service/Context/ViolationContext';
import { LicenceS } from '../../../Service/LicenceS';
import { RoutingS } from '../../../Service/RoutingS';
import LinkText from '../../../Atoms/LinkText';
import { ThemeText, ThemeTitle } from '../../../Atoms/ThemeText';
import PagePermissionGuard from '../../Security/PagePermissionGuard';
import AddTeamMemberModal from './AddTeamMemberModal';
import { openTeamAddonMissingModal, openTeamAddonQuantityModal } from './bookitupTeamAddonModals';
import TeamMembers from './TeamMembers';

const BookitupTeam = () => {
  const { executeWithLicenceCheck } = useContext(ViolationContext);
  const { bookitupTeam, isOwnProfile: isOwner } = useContext(ProfileContext);
  const { show, toggle } = useModalState(false);
  const { isPresent, addon } = useAddon('team');
  const navigate = useNavigate();

  useEffect(() => {
    RoutingS.changeTitle('Team');
  }, []);

  const openAddTeamMemberModal = async () => {
    if (!isPresent) {
      openTeamAddonMissingModal(navigate);
      return;
    }
    const shares = bookitupTeam.sharesLoaded
      ? bookitupTeam.shares
      : await bookitupTeam.ensureSharesLoaded().catch(() => bookitupTeam.shares);

    if (addon && addon.quantity <= shares.length) {
      openTeamAddonQuantityModal(navigate, addon.quantity, shares.length);
      return;
    }
    executeWithLicenceCheck(LicenceS.Restrictions.SHARE_PROFILE, toggle);
  };

  return (
    <PagePermissionGuard ownerOnly>
      <Container p={0} size={850}>
        <Stack spacing="xl">
          <Group position="apart" align="flex-start" noWrap>
            <div>
              <ThemeTitle order={3}>Team &amp; Zugänge</ThemeTitle>
              <ThemeText mt="md">
                Lade Dein Team ein, gemeinsam in bookitup zu arbeiten. Vergib passende Zugänge und entscheide, welche
                Module, Daten und E-Mail-Funktionen jede Person nutzen darf.
              </ThemeText>
            </div>
            {isOwner && (
              <div style={{ whiteSpace: 'nowrap' }}>
                <LinkText onClick={openAddTeamMemberModal} size="sm">
                  + Hinzufügen
                </LinkText>
              </div>
            )}
          </Group>
          <TeamMembers />
        </Stack>
        <AddTeamMemberModal show={show} toggle={toggle} />
      </Container>
    </PagePermissionGuard>
  );
};

export default BookitupTeam;
